import { api } from "@/lib/api";

export const ONE_PAGE_EXT = ["pdf", "ppt", "pptx", "key", "doc", "docx", "jpg", "jpeg", "png", "heic", "heif"];
export const ONE_PAGE_ACCEPT = ONE_PAGE_EXT.map((e) => `.${e}`).join(",") + ",application/pdf,image/*";
export const ONE_PAGE_MAX = 25 * 1024 * 1024;

export const validateOnePage = (file) => {
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  if (!ONE_PAGE_EXT.includes(ext)) return "Tipo de archivo no permitido. Usa PDF, PPT/PPTX, KEY, DOC/DOCX o una imagen (JPG, PNG, HEIC).";
  if (file.size > ONE_PAGE_MAX) return "El archivo supera el máximo de 25 MB.";
  return null;
};

export const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export const fetchOnePageBlob = async (pg) => (await api.get(`/one-pages/${pg.id}/file`, { responseType: "blob" })).data;

export const downloadBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  Object.assign(document.createElement("a"), { href: url, download: name }).click();
  setTimeout(() => URL.revokeObjectURL(url), 3000);
};

export async function shareOnePage(pg, blob) {
  const data = blob || await fetchOnePageBlob(pg);
  const file = new File([data], pg.original_filename, { type: pg.content_type });
  if (navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], title: pg.original_filename }); return "shared"; } catch (e) { if (e.name === "AbortError") return "cancel"; }
  }
  downloadBlob(data, pg.original_filename);
  return "downloaded";
}
